import React from 'react';
import { LucideIcon, TrendingUp, TrendingDown } from 'lucide-react';
import { Card } from '../common/Card';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
    period: string;
  };
  color?: string;
  prefix?: string;
  suffix?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  change,
  color = 'gold',
  prefix = '',
  suffix = ''
}) => {
  const colorClasses = {
    gold: 'text-gold-400 bg-gold-500/10',
    green: 'text-green-400 bg-green-500/10',
    blue: 'text-blue-400 bg-blue-500/10',
    purple: 'text-purple-400 bg-purple-500/10',
    red: 'text-red-400 bg-red-500/10'
  };

  return (
    <Card className="relative overflow-hidden">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-400 mb-1">{title}</p>
          <p className="text-2xl font-bold text-white mb-2">
            {prefix}{typeof value === 'number' ? value.toLocaleString() : value}{suffix}
          </p>
          {change && (
            <div className={`flex items-center text-sm ${
              change.type === 'increase' ? 'text-green-400' : 'text-red-400'
            }`}>
              {change.type === 'increase' ? (
                <TrendingUp className="w-4 h-4 mr-1" />
              ) : (
                <TrendingDown className="w-4 h-4 mr-1" />
              )}
              <span>
                {change.type === 'increase' ? '+' : '-'}{Math.abs(change.value)}% 
                <span className="text-gray-400 ml-1">{change.period}</span>
              </span>
            </div>
          )}
        </div>
        
        <div className={`p-3 rounded-lg ${colorClasses[color as keyof typeof colorClasses]}`}>
          <Icon className="w-6 h-6" />
        </div>
      </div>
      
      {/* Gradient overlay */}
      <div className={`
        absolute top-0 right-0 w-24 h-full opacity-5
        bg-gradient-to-l from-${color}-500 to-transparent
      `} />
    </Card>
  );
};